import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage } from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import appFetch from '../../../../api/appFetch.js';
import { AbsenceTypesUrl, AbsenceTypesWithIdUrl } from '../../../../constants/apiUrls.js';
import ModifiedByInfo from "../../../Common/Footers/ModifiedByInfo";

export default class AbsenceTypeEdit extends Component {
    constructor(props) {
        super(props);

        var absenceTypeId = undefined;

        if (this.props !== undefined) {
            absenceTypeId = this.props.absenceTypeId;
        }

        this.state = {
            id: absenceTypeId,
            description: "",
            isActive: false,
            modifiedOn: "",
            modifiedByName: "",
            modifiedByAvatar: "",
            redirect: false,
            editedAbsenceId: absenceTypeId,
            requestInProgress: false,
            redirect: null,
            open: true,
            absenceTypeWasCreated: false,
        };
    }


    componentDidMount() {
        if (this.props.location !== undefined && this.props.location.state !== undefined && this.props.location.state.editedAbsenceType !== undefined) {
            this.getEditedAbseceTypeDetails(this.props.location.state.editedAbsenceType);
        } else {
            if (this.state.editedAbsenceId !== undefined) {
                this.getDataById();
            }
        }

        this.setState({ redirect: null });
    }

    getEditedAbseceTypeDetails = (absenceTypeItem) => {
        this.setState({
            id: absenceTypeItem.id,
            description: absenceTypeItem.description,
            isActive: absenceTypeItem.isActive,
            modifiedOn: absenceTypeItem.modifiedOn,
            modifiedByName: absenceTypeItem.modifiedBy["firstName"] + " " + absenceTypeItem.modifiedBy["lastName"],
            modifiedByAvatar: absenceTypeItem.modifiedBy["profilePicture"],
        });
    }

    isValidForm = () => {
        const { description } = this.state;

        if (!description || description.trim().length === 0) {
            return false;
        }

        return true;
    }

    getDataById = () => {
        this.setState({ requestInProgress: true });

        appFetch({
            url: AbsenceTypesUrl(),
            onSuccess: (data) => {
                let absenceTypeItem = [];
                let editedAbsenceId = parseInt(this.state.editedAbsenceId);
                data.forEach(function (rowData) {
                    if (rowData.id === editedAbsenceId) {
                        absenceTypeItem = rowData;
                    }
                });

                this.setState({
                    id: editedAbsenceId,
                    description: absenceTypeItem.description,
                    isActive: absenceTypeItem.isActive,
                    modifiedOn: absenceTypeItem.modifiedOn,
                    modifiedByName: absenceTypeItem.modifiedBy["firstName"] + " " + absenceTypeItem.modifiedBy["lastName"],
                    modifiedByAvatar: absenceTypeItem.modifiedBy["profilePicture"],
                });

                return;
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    };

    handleClose = () => {
        this.setState({ open: false, redirect: "/absencetypes" });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, "") });
    };

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked });
    };

    handleSubmit = () => {
        this.saveEditedAbsenceType();
    }

    saveEditedAbsenceType = () => {
        let resources = this.props.resources;

        if ((this.state.description.length > 0 && this.state.description.trim().length <= 0) || this.state.description.trim().length > 100) {
            DisplayMessage(resources["InvalidDescripton"], "error");
            return;
        }

        this.setState({ requestInProgress: true });

        var bodyJson = {};

        if (this.state.description !== "") bodyJson.description = this.state.description;
        bodyJson.isActive = this.state.isActive;

        var json = JSON.stringify(
            bodyJson
        );

        const url = AbsenceTypesWithIdUrl(this.state.id);

        appFetch({
            url: url,
            method: 'PUT',
            body: json,
            onSuccess: (data) => {
                if (data.id !== undefined) {
                    this.setState({
                        id: data.id,
                        description: data.description,
                        isActive: data.isActive,
                        absenceTypeWasCreated: true,
                        redirect: "/absencetypes"
                    });

                    DisplayMessage(resources["AbsenceTypeEdited"], "success");
                }
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }


    renderForm() {
        const handleSubmit = (event) => {
            event.preventDefault();
            event.stopPropagation();
        };

        const { isActive, description, modifiedByAvatar, modifiedByName, modifiedOn } = this.state;
        var resources = this.props.resources;

        return (
            <Paper elevation={3} className="p-4 mt-3 mb-3">
                <Form onSubmit={handleSubmit} >
                    <Form.Group className="pt-3" style={{ display: "flex" }}>
                        <div className="col-md-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-md-6 helper-text-red" id="absencetype-description" value={description} label={resources["Description"]}
                                variant="outlined" name="description" onChange={this.handleChange} inputProps={{ maxLength: 100 }} />
                        </ThemeProvider>
                    </Form.Group>

                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="absencetype-is-active" checked={isActive} onChange={this.handleChangeCheckBox} name="isActive" color="primary" />}
                            label={resources["IsActive"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                </Form>
                <ModifiedByInfo
                    resources={resources}
                    modifiedByAvatar={modifiedByAvatar}
                    modifiedByName={modifiedByName}
                    modifiedOn={modifiedOn}
                />
            </Paper>
        );
    }

    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return <div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')} style={{ textAlign: "center" }}>
            {this.renderForm()}
        </div>;
    }

    render() {
        const { open, redirect, absenceTypeWasCreated, requestInProgress } = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect

        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: absenceTypeWasCreated } }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton id="close-edit-absencetype" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["EditAbsenceType"]}
                            </Typography>
                            <Button id="absencetype-save" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSubmit}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>
                </Dialog>
            </div >
        );
    }
}